import {POST_MESSAGE} from '../../actions/input-field/index';

const initialState = {
};

export default function(state = initialState, action) {
  switch (action.type) {
    case POST_MESSAGE:
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/input-field/index.js